var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"placeholder":_vm.$t('post.sidebar.toSearch')},model:{value:(_vm.toSearch),callback:function ($$v) {_vm.toSearch=$$v},expression:"toSearch"}})}
var staticRenderFns = []

export { render, staticRenderFns }